module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("B")])]), _vm._v("randt stood near the breakfast room window holding his newest cousin in his arms. ‘Tree,’ he said, pointing to an example on the other side of the glass. He had no idea what sort of conversation one made with a five-month old human, although the young Marquis of Wroth did not seem at all dismayed by his efforts. He made a gurgling sound and Brandt looked down to find the child’s solemn unwavering gaze on his face. Was he about to cry? Brandt cleared his throat. ‘I fear your mama has left you in very inexperienced hands. She should be back shortly. I hope.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("The small mouth suddenly moved. Brandt braced himself for a scream. To his astonishment, he realised his tiny cousin was actually smiling at him. He found his own mouth tentatively curving in response as he stared down at the babe. He gently touched the soft cheek and young Julian gurgled again. A small finger came up to grasp his. Unexpected warmth flowed through Brandt and he suddenly knew exactly why his cousin was so thoroughly in his son’s thrall. Certainly he had seen Julian before at his christening when he had been the child’s godfather, but he had resisted doing more than briefly hold the babe, fearing he would harm such a small and helpless life. Somehow ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("his cousin’s happiness had made him feel left out, but now he was beginning to regret he had stayed away so long.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He heard footsteps. He lifted his head. Expecting Belle, he was startled to see Chloe instead. She looked equally taken aback. Her gaze fell to Julian and her eyes widened in astonishment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The Duchess decided I should play nursemaid while she went to confer with Mrs Keith.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I see.’ Her expression was controlled as it always was around him. She wore a gown of creamy muslin tied with a green sash. Her dark auburn hair was tamed into a knot at the back of her head, but a few tendrils framed her face. She looked fresh and pretty. And completely untouchable. He had no idea why a girl whose smile could hold so much warmth managed, at the same time, to neatly keep any potential suitors at bay. That she disliked him he was well aware of, and, to some extent, he could not blame her, but that she would spurn the advances of other eligible young men puzzled him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As did her behaviour last night at the card table. Any fool could see she was no novice. Then why go through the pretence of having Kentworth instruct her? Even more puzzling was how horrified she had looked right after she had won, and even more so after he had taken her from the card room. She had appeared much better after he returned with the lemonade, and Belle had said nothing more than that Chloe had become overheated and that, after her illness, she was still inclined to fatigue. Nothing had been said about cards, so perhaps her reaction had been only in his imagination after all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julian struggled in his arms. He looked down and saw the babe was reaching towards Chloe. ‘I think he wants you.’ He cast a doubtful look at her gown. ‘If you want him.’")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Of course.’ She stepped closer to him, held out her arms and took the infant. The babe snuggled against her and then turned his head to look back at Brandt. He offered Brandt another tentative smile. Chloe glanced down at the child, her expression softening, and then back up at Brandt. ‘He likes you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I would hope so since we are related.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I doubt that is the only reason.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And what other reason might there be?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I…’ She looked flustered. ‘You are…are kind.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ah. A compliment from your lips. I shall treasure it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Colour flooded her cheeks. ‘There is no need to be so sardonic.’ Her face closed again and she looked quickly down at the child.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He bit back a curse. He had no idea why he was so boorish around her. ‘I beg your pardon.’ He picked up the silver pot from the table. ‘Will you take tea or coffee? Or chocolate.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I always take tea.’ She looked flustered again. ‘You do not need to pour me anything.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But you are occupied, so it is the least I can do.’ He poured the tea into one of the china cups. ‘Sit down. How much sugar?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still looking taken aback, she sat in the nearest chair. Julian promptly picked up a spoon. ‘Two, if you please.’ She watched Brandt spoon the sugar into the cup. Almost as soon as he set the tea in front of her Julian reached for it. Chloe pulled the child back just before he grasped his object. The spoon fell from his hand and he started to cry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brandt stared at him, completely at sea. ‘Should I find Belle?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No. Pick up the spoon.’ She stood and started to gently bounce the child, speaking to him in soft tones.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Brandt retrieved the spoon from under the chair. He held ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("it out to Julian, who had stopped crying. Instead of taking the spoon, he sniffed and held out his arms to Brandt.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He wants you again,’ Chloe said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’ve no idea why. He would do much better to stay with you. What if he starts to cry again?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julian wriggled and reached towards Brandt. He made a little sound of protest. Chloe smiled at the child and then looked back at Brandt. ‘He will probably start to cry if you do not take him. Here…’ she held Julian out ‘…you were doing very well when I came in.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once again he found himself holding a chubby, pink-cheeked bundle who fixed him with a dazzling smile. It occurred to Brandt that he could not recall the last time someone had smiled at him with such pure, joyous pleasure at merely being in his presence. He smiled back at the babe with the oddest sensation he would never be the same again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘See, there was nothing to be afraid of.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked up at Chloe and found her watching him. Even more amazing, she actually smiled at him. For the second time in the space of a minute, he nearly reeled. ‘No. He is…is charming.’ That seemed completely inadequate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He is.’ She was still smiling, the warm smile he’d only seen once or twice, the smile that lit up her face and rendered her incredibly lovely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He felt as if he’d been punched in the stomach. Her smile faded as she took in his expression. Julian started to wriggle and make happy, impatient noises. When Brandt tore his gaze from Chloe he saw why. Justin and Belle had just entered the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Duke of Westmore stopped. ‘You look amazingly domestic. I feared I might find you cowering in the corner when Belle told me she had left Julian with you.’")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Fortunately Chloe came shortly after Belle departed and rescued me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He really did not need to be rescued,’ Chloe said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced at her, surprised at her defence of him, but her expression had reverted back to the same guarded one she always wore.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julian squealed again and held his arms out towards his father. Justin’s dark face broke into a smile as he took his son. He planted a brief kiss on the child’s head and then looked at his wife. She met his eyes, a little smile on her face. For a moment, the three of them existed in a timeless bond that excluded the rest of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Longing shot through Brandt, swift and hard. He forced his eyes away only to meet Chloe’s. Their gazes locked and for an instant he saw the same yearning reflected in her face and he knew she read his mind as clearly as he read hers. She quickly looked away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He pulled his gaze away as well, disconcerted by the connection between them. He wanted to escape. ‘Now that you no longer need my services as nursemaid, I will take my leave. Carlton has the final papers ready for me to sign.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Then it is not yet too late for you to change your mind,’ Justin said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’ve no intention of doing so at this point.’ He grinned at Belle. ‘I fear you will find me underfoot more often than you might want.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She smiled back at him. ‘I doubt that. I am only a little angry you have not been to visit more often. I feared Julian would consider you a stranger.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced down at the child who had so suddenly stolen his heart. ‘You no longer need to fear that,’ he said softly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("He took his leave, only nodding to Chloe. For once he ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("felt no desire to tease her. In fact, avoiding her as much as possible seemed the best tactic.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was nearly at the solicitor’s office before he recalled that while he had been procuring a lemonade for Chloe last night, he had been approached by Miss Sutton. She had invited him to attend an afternoon of dancing lessons at her house. She hoped he might consider it even if Chloe had expressed the opinion that he would find it dull, which had been enough to secure his immediate acceptance. Particularly when he had heard Chloe would attend. He had looked forward to proving that he was not nearly the jaded sophisticate she seemed to see him as. Now, the prospect had lost some of its appeal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This morning had merely been an aberration. Undoubtedly, she would be back to regarding him with the same disapproval as always and he would treat her in the same teasing fashion as if nothing had happened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the future, he would avoid any situations in which he found himself alone with her with only a baby as a chaperon.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe sat back down at the breakfast table, her thoughts in turmoil. Whatever had happened? For a moment, when her gaze locked with Brandt’s, she had known exactly what he was thinking, but more than that, exactly what he was feeling; she had glimpsed a vulnerable side to him that rendered him completely human. But she had already been thrown off when he had reluctantly taken Julian, the arrogant, cool peer suddenly stripped away by the mere thought of holding a baby. When his face had softened as he looked down at the child and then looked up at her and pronounced him charming, her antagonism had melted away.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Chloe?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She realised she had been staring at her toast. ‘I…I fear I was wool-gathering.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I can see that. Are you still worried about last night? Or did Brandt say something to distress you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He said nothing. He was worried about holding Julian.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Belle smiled. ‘Men do that. I have never seen Brandt look quite so dismayed as when I told him to hold Julian while I spoke to Mrs Keith. He tried to protest, but I told him it was time he became better acquainted with his godson. I imagine he was overjoyed when you arrived, although I was quite surprised to find him still holding Julian. I would have thought he would wish to hand him over to you straight away.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He did, but Julian made it very clear he wanted Brandt again. I told him if he did not take him, Julian would cry.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Belle laughed. ‘Very good.’ She poured herself another cup of coffee and eyed Chloe. ‘It does not sound as if you were at daggers drawn then.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘For once we were not.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Good. I rather hope you might become friends of a sort.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I doubt that. We do not rub along well together.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Are you certain? I rather think it is mostly on your side. I still have no idea why you hold him in such dislike.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He is too arrogant, I suppose. He is just the sort of man I do not like very well.’ Chloe looked down at her teacup.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That is unfortunate, for I rather think he likes you,’ Belle said gently.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe’s head jerked up. ‘I doubt that. He teases me mercilessly and seems to delight in annoying me as much as possible.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I rather expect he does so to get your attention. Otherwise you tend to snub him.’")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Heat stained Chloe’s cheeks. She could not deny the accusation as much as she wanted to. It was not in her nature to deliberately hurt someone, but she had excused her rudeness to Brandt because she doubted he had any feelings to hurt. ‘I suppose I still cannot forgive him for how he treated you in the beginning. To think that you could possibly be involved in Lucien’s plot to destroy Justin.’ She would never forget how cold he was to Belle, the first time Chloe had met him at a musicale. She had detested him on the spot for that alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But that’s in the past. And certainly you disliked Justin equally, but you do not seem to bear any ill will towards him now. If anything, he set out to hurt me whereas Brandt was merely attempting to protect his cousin. Just as you were attempting to protect me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I know.’ Certainly her feelings were irrational. When Justin had returned to England a year ago he had every reason to believe that Belle had been an accomplice in Lucien’s plot to destroy Justin’s father by killing Justin in a duel. Instead Lucien had been wounded and Justin had been exiled to the continent. Intent on revenge, he had set out to make Belle his mistress. So, if anything, Chloe should detest Justin, but how could she when he so obviously loved Belle and now Julian? And when he made her so welcome when he could very well detest her as Lucien’s half-sister?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘There is another reason I hope you might come to like Brandt.’ Belle paused. ‘He is soon to become our neighbour.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a sinking heart, Chloe knew Mr Rushton had been right. ‘He’s bought Waverly.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘How did you know that?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Mr Rushton said something about it last night.’ She bit her lip. ‘Why did you not tell me?’")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He asked us not to say anything as there was some dispute over the title that needed to be resolved and he did not want more rumours to complicate the matter. He will complete the purchase of Waverly today.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But I cannot imagine why he would want it! It is old and neglected and has no modern conveniences. Why can he not live at Salcombe House?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He does not like Salcombe House,’ Belle said gently.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But how can he possibly have the funds to do so?’ she blurted out and was instantly ashamed when she saw Belle’s quietly reproving expression. ‘Oh, Belle, I am so sorry. I should not have said such a rude thing. It is none of my affair at all.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, it is not, but I’ve no doubt others will ask the same thing. He sold most of his unentailed properties in order to pay off his father’s debts and make the necessary improvements to his estate. He invested whatever was left and I assume it is from those monies he is purchasing Waverly.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He must want it very much. I suppose I do not understand why.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Belle looked steadily at Chloe. ‘I imagine it is because he fell in love with the house the first time he saw it. Just as you did.’")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("Brandt paused for a moment outside the gate to the Suttons’ pleasant brick house. What the devil was he doing? He had no desire to participate in the sort of entertainment he envisioned; a gaggle of young ladies and their admirers going through the steps of the newest dances. Just the sort of rustic entertainment he would expect from an unsophisticated village such as Weyham. The sort of entertainment he had never had the opportunity to enjoy. His mother’s constant illnesses and his father’s rigid morality and cold ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("disregard for most of his neighbours had not encouraged mixing with the local gentry. After his mother’s death, when Brandt finally went out into society, he fell in with the most wild, rakish crowd possible. Not until his father was found dead in one of London’s most notorious brothels did he come to his senses. By then, he was too disillusioned to enjoy such simple pleasures as an afternoon of practising dances.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which was why he had no idea why he was standing here now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Planning to go in, Salcombe?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gilbert Rushton’s voice startled him. He turned. ‘I am still debating.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘A bit too late for that. Miss Sutton is leaning out of the window. Bad "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _vm._v(" if you were to walk away now.’ He grinned at Brandt. ‘Don’t worry, only a couple of hours at the most.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Miss Sutton was indeed waving at them from a first-floor window. He followed Rushton up the path. ‘So, Miss Sutton talked you into this as well?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Precisely. However, when I discovered Lady Chloe would be here, I didn’t need much persuading.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Lady Chloe?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘She’s a deuced pretty gal, clever, and an heiress to boot. Some men might resent a gal who could best them at the table, but not me. Always like a bit of spirit and brains. Besides, one never knows when a way with the cards might prove profitable.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brandt was unaccountably annoyed. ‘I doubt Lady Chloe wishes to exploit her talent for profit.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By now they had reached the front door. Rushton glanced at him. ‘Not intruding on your territory, am I?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Not at all. I’ve no interest in Lady Chloe. That is, beyond that of a relation.’")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Then no objections if I pursue an acquaintance with her?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh, he objected all right. He hardly wanted her to fall under the charm of a loose screw like Gilbert Rushton. ‘No, unless you trifle with her.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Intentions are strictly honourable.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That hardly reassured him. But the pink-cheeked housekeeper had opened the door and after taking their coats and hats and Rushton’s cane, ushered them into the sunny, crowded drawing room. The furniture had been pushed aside to clear a space for the dancing. Half a dozen young people were already clustered around the piano. Chloe, however, sat on a small sofa with Sir Preston. She glanced up, her expression astonished, and then looked quickly away. Brandt quelled his desire to march over and say something to fluster her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mrs Sutton greeted them with a pleasant smile. ‘Good day, Gilbert. How delightful to see you, Lord Salcombe. We cannot tell you how splendid it is to have you among us. We so feared Waverly would be pulled down and—’ She stopped at his expression. ‘Oh, dear! I fear I have said something when I should not…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had not quite been able to keep the surprise from his face. ‘Not at all. I have just signed the final papers today so I no longer wish the matter kept private.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The anxiety left her face. ‘How delightful!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So the rumours were true! Congratulations!’ Rushton said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Everyone else gathered around to offer their congratulations and pleasure at the restorations taking place. Everyone except for Chloe, who hung back, her expression closed. Brandt was annoyed. She might not be delighted, but she could at least offer a token word.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("Lydia finally turned to Chloe. ‘See! I knew Lord Sal")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("combe would come today. He assured me he would not find this at all dull as you said he would.’")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I see,’ Chloe said faintly. She did not look at him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia was all smiles. ‘Shall we begin? Harriet will play. We will first perform a country dance so Sir Preston might see how it is properly done. Then he can try it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sir Preston tugged at his cravat. ‘Er, certainly.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do not worry. We can take it very slowly,’ Chloe told him. She gave him a reassuring smile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But do you not think it will be too confusing if we are all dancing at once?’ Emily said. She stood near the pianoforte, observing the company with her usual disdainful gaze. Her eye fell on Brandt. ‘I think it would be best if Lady Chloe and Lord Salcombe demonstrate the steps first since they have been in London the most recently. I dare say they are the most expert.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe looked taken aback. ‘I do not know if that makes me very expert at all.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And I rarely dance,’ Brandt said. He crossed his arms, his mood surly. He had no intention of forcing himself on Chloe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But I was,’ Rushton said. ‘I should be happy to partner Lady Chloe.’ He sent her a smile that set Brandt’s teeth on edge.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Then Lydia may partner Lord Salcombe,’ Emily said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia, who had looked increasingly annoyed at Emily’s interruption, suddenly brightened. ‘That is a splendid idea. Two couples will make it much more easy to observe.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Here, here. Now that we’ve settled that, let’s get on with it,’ Tom Coltrane said. He stood near the pianoforte with Henry Ashton, attempting to affect a look of bored amusement.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("They took their places in the middle of the room and Harriet launched into an uneven country dance. Brandt, ")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("who had danced at numerous balls with the most haughty members of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _vm._v(" in attendance, suddenly found himself attacked by an unexpected bout of self-consciousness because he was on display in front of a mere handful of people. Harriet’s choppy rhythm and the fact she tended to repeat passages whenever she hit a wrong note made keeping time nearly impossible. Rushton’s low-voiced flirtation with Chloe threw Brandt off further. And when he handed off Lydia and found himself reaching for Rushton’s hand, he had no idea whether to laugh or curse.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Sorry,’ Rushton said. ‘Lydia, where are you? Salcombe, here, you take Lady Chloe.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The others were beginning to titter. She stared at him and he saw her mouth begin to quiver. ‘Chloe?’ he asked. ‘Are you all right?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Y…yes.’ She bit her lip and then a laugh escaped her. She stopped and Lydia careened into her. ‘Oh, dear…P…please do not say anything more.’ She clapped her hand over her mouth and he saw she was laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He grinned. The rest of the company was now laughing except for Lydia. ‘Oh, do stop!’ she cried. ‘It was not that dreadful!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But it was!’ Tom held his sides. ‘Is that what they do in London? Had some idea those "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _vm._v(" balls were a bit stodgy! Seems I was wrong!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even Sir Preston was grinning. ‘Could have shown you that myself.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia marched over to the pianoforte. ‘Harriet! Could you not have tried?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Harriet jumped up. ‘I told you I hate to play for dances!’ She looked as if she were about to burst into tears.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("‘Never mind, Harriet,’ Emily said briskly. ‘Dances are always difficult. You can stand up with Tom, and I will ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("play this time.’ She gave her brother, who was still wiping his eyes, a meaningful look.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Er, yes.’ Tom held his arm out to Harriet. She beamed at him as they took their places along with the others.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This time everything went smoothly. When it was over, Emily stood. ‘I know you play most delightfully, Lady Chloe. Perhaps you can play this time and I will show Sir Preston the proper steps.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brandt glanced at Chloe in time to see a peculiar look cross her face. She glanced at Sir Preston and finally said, ‘I fear I am like Harriet and cannot play for dances.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, I doubt that,’ Emily said. The smile she bestowed upon Chloe was hardly sincere.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do play, Chloe!’ Lydia said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe walked to the instrument and sat down, but it was obvious she was not pleased. Emily took Sir Preston’s hand and then went through the steps in her no-nonsense fashion. When the dance began, it was apparent Emily’s instructions had been adequate; Sir Preston only misstepped once.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After that, Mrs Sutton bustled in, followed by the housekeeper who carried a tray of refreshment. Despite the cheerful chatter of everyone else, Chloe seemed subdued and distracted. Brandt, intending to keep his distance, instead found he wanted to inquire what was wrong. Before he could extricate himself from Lydia, Gilbert Rushton took the place next to Chloe on the sofa. He said something to her, and she gave him a slight smile that set Brandt’s back up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do you plan to make your home at Waverly, Lord Salcombe?’ Lydia was asking him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, I am, Miss Sutton.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("‘But you will keep a house in town, will you not? I ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("imagine you must find Weyham very dull after the delights of town.’")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Not at all. We rarely have entertainments such as this in London.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But you will be going to London often.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do you wish to see me gone from the neighbourhood so soon, Miss Sutton?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She coloured. ‘Oh, no! I merely thought that you would wish to go there often.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Actually, I don’t intend to spend much time at all in London except when necessary. Waverly will keep me occupied.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked disappointed for some reason. Miss Coltrane, who seemed to have appointed herself in charge of the entertainment, stood. ‘We can practice the waltz. However, this time Lord Salcombe and Lady Chloe must first demonstrate.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brandt looked over at Chloe and waited for the inevitable reason why she could not stand up with him. She met his sardonic gaze and lifted her chin. ‘I would be glad to do so if Lord Salcombe does not object.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I do not object, as long as you don’t, Lady Chloe.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I thought that was what I just said.’ She came to his side.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So, what has made you decide you would care to stand up with me after all?’ he murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If you must know, I still owe you a dance. I merely wished to repay my debt.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d nearly forgotten about that. ‘Ah, although performing the waltz in someone’s drawing room was hardly what I had in mind.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Miss Coltrane played a few notes and then peered around the music at them. ‘I believe the gentleman is to take the lady’s hand and then put his hand at her waist.’")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If you don’t know the waltz, Salcombe, I can take your place,’ Rushton said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brandt started. ‘Should we proceed, Lady Chloe?’ He held up his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She placed her hand in his. While he put his other hand on the small of her back. Miss Coltrane began the music. After a moment of hesitation, Chloe followed his lead easily. He forgot he was in a small drawing room with an assortment of onlookers—he was only aware of the pleasurable feel of her slender back, the delicate touch of her hand in his, the face so sweetly upturned towards him, her mouth soft and inviting. A vision of crushing those lips beneath his made him catch his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He heard her own intake of breath and her eyes widened as if she guessed his desire. The music came to an abrupt halt and he jerked his gaze away. What the hell was he doing, practically making love to her in the middle of the afternoon in a country drawing room? He dropped his hands and gave a slight bow. ‘Thank you for the dance, Lady Chloe.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She curtsied. ‘Thank you, Lord Salcombe.’ She did not quite look at him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was silence and then Rushton applauded. ‘Splendid! A worthy performance that quite makes up for the less than spectacular beginning.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe turned to Sir Preston. ‘Do you wish to try, Sir Preston? I should be quite happy to show you the steps. Miss Coltrane did such a splendid job of playing I am certain she would be glad to play again.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, most certainly,’ Miss Coltrane said with a cool smile.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("This time she played the waltz as if it were a requiem. However, Brandt was distracted from speculating why by Chloe’s efforts to teach Sir Preston the finer points of ")]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("waltzing. The sight of her guiding Sir Preston’s hand in the appropriate position and the warm colour in her cheeks made him wish he were in need of instruction. The only gratification was that Sir Preston didn’t appear to be nearly as affected by Chloe’s efforts as Brandt was by watching them. The baronet’s sole concentration centred on executing the steps correctly.")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Sir Preston finally danced without a misstep, she smiled at him in such a way that Brandt was pierced with jealousy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mrs Sutton insisted on playing so that everyone might dance. After another country dance and a cotillion, Miss Coltrane announced it was time for her to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The others followed suit and the party broke up. Brandt took his leave of Mrs Sutton and she smiled up at him. ‘How delighted we were to have you today! I hope you will not find our little corner of England too dull. We have the assemblies and sometimes there is a dinner party, but I dare say they are nothing compared to the splendid entertainments of London. Except for Lady Haversham’s summer ball. I imagine you will be here for that?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At that moment he heard Rushton say, ‘Perhaps I could escort you home, Lady Chloe.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brandt realised Mrs Sutton was waiting for his reply so he pulled his attention back away from Chloe, irritated that he could be so easily distracted. ‘Yes, I will be here.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mrs Sutton beamed. ‘Splendid. It is always the most elaborate affair…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He finally managed to escape, but once outside he saw no sign of Chloe. Rushton was conversing with Tom Coltrane, so at least Chloe had possessed the sense to refuse his offer. Of course, what she did was none of his concern. He’d best remind himself of that.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe walked slowly up the lane, feeling curiously disgruntled. She had no idea whether today could be counted as a success or not. Certainly she had spent some time sitting with Sir Preston before the others arrived. But once Emily and Tom came, the conversation turned to racing, a topic Chloe knew little about. Brandt’s unexpected arrival had only thrown the afternoon off even more, particularly when Lydia made the remark about him not finding the entertainment dull. Chloe had wanted to sink.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As the afternoon progressed, she realised that, for some reason, Emily was determined to keep her away from Sir Preston. At least Chloe had managed to thwart Emily in the end when she showed Sir Preston the waltz. For some reason, however, it had felt rather flat after waltzing with Brandt. Of course, Brandt was very experienced and had undoubtedly danced dozens of waltzes so naturally it would be more interesting. But that did not explain why, when Brandt took her hand and then rested the other on her back, a peculiar tingle raced through her. And why, when Sir Preston did the same thing, she felt nothing at all. Or why the look in Brandt’s eyes when they finished made her heart skip a beat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The only reason she had agreed to waltz with him was because of her promise last night. And because he had looked at her in that knowing way as if he was just waiting for her to cry off. She had wanted to prove him wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which was idiotic. As was thinking about him when she should be thinking of Sir Preston instead. He was the sort of safe, trustworthy man she wished to marry. A man she would be comfortable with. A man who did not overpower her, treat her as if she were incapable of thinking for herself. Not the way her father had. Or the way Lucien had. Or the way Arthur still did.")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A cool, confident, overbearing man such as Brandt would be no different.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She heard her name. She turned to see Emily hurrying after her. She bit back a groan. Emily was the last person she wanted to see at this moment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She caught up to Chloe. ‘You certainly waltzed very well with Lord Salcombe. How kind of you to take the time to show Sir Preston the steps, although I doubt your expert instruction will have quite the same results for him as his expert instruction in cards has had for you. Particularly after last night.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I was merely lucky last night. As you pointed out.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I don’t suggest it was luck for you. In fact, I think you are quite talented. But such talents run in your family, do they not?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was no doubt referring to Lucien. Chloe felt as if she had been struck, but she managed to keep her voice calm. ‘Such talents seem to run in most people’s families.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Perhaps. Lord Salcombe did not seem at all dismayed that he was bested by a mere female.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The game was not between Lord Salcombe and me. Sir Preston and Mr Rushton also played.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Poor Sir Preston. Anyone could see that you carried the game. I would imagine that must have been very humiliating.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I hardly think of Sir Preston as “poor”! He played very well and sometimes it is merely a matter of which cards are drawn. I should be happy to have him for a partner any time.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Emily gave a little laugh. ‘How quickly you come to his defence. One would almost think you have a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tendre")]), _vm._v(" for him.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("Her manner indicated no woman in her right mind would ever consider such a thing. ‘I can imagine any num")]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("ber of women developing a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tendre")]), _vm._v(" for Sir Preston,’ Chloe said.")])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So you do! I would think you would prefer a man such as Lord Salcombe to someone as dull as Sir Preston.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I never said I had a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tendre")]), _vm._v(" for Sir Preston.’ Chloe’s cheeks heated. ‘I do not consider him dull, at any rate. I have no idea why you think I would prefer Lord Salcombe.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He is more sophisticated and has more address and I cannot imagine him thinking only of his land. Or his horses and dogs, and shooting. One must have something in common with the object of one’s affection after all. I do not suppose you are interested in farming and dogs and sheep?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Of course I am.’ She was beginning to resent this line of questioning very much. ‘Not that it is any of your concern.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Emily gave her a superior smile. ‘Poor Sir Preston. Does he suspect? No, of course not. He is too thick.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe wanted to hit her. ‘I do not have a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tendre")]), _vm._v(" for anyone. If you must know, I have no intention of falling in love. I like Sir Preston because he is kind.’ Thank goodness, they had reached the path Chloe needed to take to reach Falconcliff. ‘I must go this way. I pray you will not repeat such speculations to anyone. They are quite untrue.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, I shan’t say a thing,’ Emily said breezily. ‘But I think you would do better to set your sights on Lord Salcombe. Good day, Lady Chloe.’ She walked away, her head high.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe stared after her. Oh, heavens! What if Emily said something? She would die of humiliation if anyone else thought she was setting her cap at Sir Preston.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("Particularly Brandt. She could only imagine his amuse")]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_vm._v("ment. No, she did not want anyone to know until she and Sir Preston were betrothed.")])]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If, indeed, that happened.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe’s disgruntled feeling only increased when she entered her bedchamber and found a letter on her dressing table from Arthur. She tore off her gloves and picked up the missive. He never wrote unless he wished to admonish her for spending all of her pin-money. In her present mood, she looked forward to his certain lecture even less than usual.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her first impulse was to put the letter off until later. On the other hand, she might as well open it and put it out of her mind. She broke the seal and spread open the paper. ‘Oh, no,’ she whispered. Surely, she had misread what he wrote.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But another read of his neat, precise handwriting left no doubt. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Marquis of Denbigh and his sister, Lady Barbara, have most graciously invited us to a house party at Denbigh Hall. I will arrive at Falconcliff ten days after Lady Haversham’s ball, but rather than going to Dutton Cottage we will leave directly for Denbigh Hall the following day.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_vm._v("Not Lord Denbigh, who reminded her of a large frog with his great bulk, bulging eyes and clammy hands! She had met him this past Season and had hardly thought of him at all when he was first presented to her, except that he was the sort of man she disliked for he reminded her of Lucien’s acquaintances. She had been puzzled as to why his widowed sister, the sophisticated Lady Barbara Grant, took an interest in her, inviting Chloe to the theatre, seeking her out at assemblies, taking her for drives in her stylish barouche. Chloe began to notice that Lord Denbigh was almost always present as well. She tried to avoid him; the ")]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_vm._v("expression in his eyes when he looked at her made her uneasy. But one evening, when she and Mama were invited to Lady Barbara’s home for dinner, Lady Barbara left Chloe and Denbigh alone in the small garden behind the Denbigh town house. He suddenly declared that she was the sweetest creature alive and had pulled her into his arms and kissed her with his wet, thick mouth. His breath and odour had nearly made her gag and only when she had started to retch did he draw back. He had called for Lady Barbara.")])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lady Barbara accepted his explanation that Chloe had suddenly taken ill while strolling in the garden. Maria had fussed over her, insisting she must stay in bed the next day. Horrified and ashamed, Chloe could not tell her mother about the kiss. Just as she had not told her mother about an earlier, even more brutal kiss. Chloe ended up ill anyway, for the day after that, she developed a fever and her body ached everywhere. After several weeks, she had still remained weak. The physician finally suggested that the air of London might be responsible and that the fresh air of the seaside would undoubtedly prove beneficial. By then she was eager to escape London and the fact that Belle had invited her to Falconcliff for an indeterminate amount of time pleased her even more. Thus her Season had ended, and, with it, she had thought, the attentions of Lord Denbigh, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What was she to do? The thought of facing Lord Denbigh again filled her with panic. If only Sir Preston would make her an offer! She turned from the window, still clutching the letter. If they were betrothed, then surely she would not be expected to go to house parties at Denbigh Hall or anywhere else. She could stay at Falconcliff until the marriage and then after that she would be here in Devon for ever.")])]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She sat down on the bed. Certainly Sir Preston had been all that was kind and attentive, but he was not particularly polished in matters concerning females. He rather reminded her of Serena’s betrothed, Charles Hampton. Serena, who was her dearest friend, had written that she had been forced to bring her Charles up to the mark.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How had she done it? Chloe rose and rummaged through the small wooden box where she stored her letters until she found Serena’s letter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I will own I was forced to take matters into my own hands, for I fear Charles would never come up to scratch if I did not. You would probably be shocked at my boldness, for I know how proper you like to be! During last night’s assembly I asked him to escort me to the garden under the pretext that the room was far too warm. There was a nicely secluded bench and we sat. Then I told him I was rather cold and moved very close to him. I then smiled at him, but instead of looking away I held his gaze. In a most bold fashion! And then he kissed me, very nicely I must add, and after that he felt most obliged to make me an offer, which I modestly accepted.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The kissing aspect made her feel slightly ill, but if she married Sir Preston there would need to be kisses—as well as other more intimate contacts she shied away from thinking of. Perhaps one grew used to such things after a while.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Certainly Belle had, if the dreamy look in Belle’s eyes when Justin regarded her in a particular way was any indication. But then she was in love with Justin and he was in love with her, so that undoubtedly made the difference. At such times, Chloe was uncomfortable, almost as if she had intruded on their privacy, but at least she had not felt repulsed by their mutual desire. Unlike the revulsion she experienced when Denbigh looked at her. Or when Lucien’s acquaintances had stared at her so long ago.")])]), _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which was another reason, she felt safe with Sir Preston. He never looked at her in such a repugnant way. At least, she cared very much for Sir Preston, so perhaps she would not mind his kisses. And she wanted children, soft, rounded babies who would grow into lovable children, which meant she must learn not to mind such intimacies.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Could she possibly force Sir Preston’s hand? She cringed at the thought, but she could see no other way to approach him before she was forced to leave with Arthur.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Arthur would arrive in less than a fortnight. She must think of something before then.")])])]), _c('a', {
    attrs: {
      "id": "page48"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page48"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60cd1335","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459231535_ch02.vue
// module id = 78
// module chunks = 0